/*
    Add here your own custom javascript
*/

// Fix for the RTL language in the demo
document.querySelectorAll('[href="/ar"]').forEach(link => {
    link.setAttribute('target', '_blank')
})

// EcomGraduates - Affiliate tracking code
function addRefParamToUrlsAndSetCookie () {
    const urlParams = new URLSearchParams(window.location.search)
    let refParam = urlParams.get('ref')

    if (!refParam) {
        // Check if the "ref" cookie exists
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim()
            if (cookie.startsWith('ref=')) {
                refParam = cookie.substring(4)

                urlParams.set('ref', refParam)
                break
            }
        }
    }

    if (refParam) {
    // Set the "ref" cookie with the "ref" parameter value
        document.cookie = `ref=${refParam}; expires=${new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}; path=/`

        // Update the URLs on the page with the "ref" parameter value
        const links = document.getElementsByTagName('a')
        for (let i = 0; i < links.length; i++) {
            const link = links[i]
            const url = new URL(link.href)
            if (url.hostname === 'ecomgraduates.com') {
                if (url.search) {
                    url.search += `&ref=${refParam}`
                } else {
                    url.search = `?ref=${refParam}`
                }
                link.href = url.href
            }
        }
    }
}
// addRefParamToUrlsAndSetCookie()

/* 27N · Placas de matrícula: campos obrigatórios iguais ao site antigo
   (Matrícula + NIF; Mês/Ano nas placas com data; Classe nas máquinas industriais) */
(function () {
  var w = document.getElementById('ea-opts');
  if (!w) return;
  var inp = w.querySelector('input[name="properties[Matrícula]"]');
  if (!inp) return;
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  var handle = m ? decodeURIComponent(m[1]) : '';
  var pv = document.getElementById('ea-pv');
  var title = (pv && pv.getAttribute('data-t')) || document.title || '';
  var NONE = ['aro-cromado-sem-matricula-155x155mm', 'kit-de-manupulacao-de-chapas', 'kit-matricula-de-motociclo-com-aro-cromado-155x155mm', 'matricula-transporte-de-animais-vivos-520x110mm'];
  var CLS = ['matricula-de-maquinas-industriais-acrilica-quadrada-340x220mm', 'matricula-de-maquinas-industriais-acrilica-rectangular-520x110mm'];
  if (NONE.indexOf(handle) > -1) {
    w.style.display = 'none';
    w.querySelectorAll('input,select,textarea').forEach(function (x) { x.disabled = true; });
    return;
  }
  var free = /texto livre/i.test(title);
  var withDate = /1998/.test(title) || /cl[aá]ssica/i.test(title) || handle === 'kit-vespa-1';

  inp.required = true;
  if (!free) inp.placeholder = 'Ex.: AA-00-BB';
  var cor = w.querySelector('select[name="properties[Cor da Personalização]"]');
  if (cor) cor.required = true;

  function el(html) { var d = document.createElement('div'); d.innerHTML = html; return d.firstChild; }
  var g = inp.closest('.ea-g') || inp.parentNode;
  var after = (pv && g.nextSibling === pv) ? pv : g;
  function add(node) { after.parentNode.insertBefore(node, after.nextSibling); after = node; }

  if (!free) {
    add(el('<div class="ea-g"><span class="ea-l">Nº Contribuinte (NIF) *</span>' +
      '<input type="text" name="properties[Nº Contribuinte (NIF)]" inputmode="numeric" pattern="[0-9]{9}" maxlength="9" placeholder="000000000" title="NIF com 9 dígitos" required>' +
      '<div class="ea-n">NIF do proprietário da viatura (9 dígitos).</div></div>'));
  }
  if (withDate) {
    var meses = ['01 - Janeiro', '02 - Fevereiro', '03 - Março', '04 - Abril', '05 - Maio', '06 - Junho', '07 - Julho', '08 - Agosto', '09 - Setembro', '10 - Outubro', '11 - Novembro', '12 - Dezembro'];
    var opts = '<option value="">Mês</option>' + meses.map(function (x) { return '<option value="' + x + '">' + x + '</option>'; }).join('');
    add(el('<div class="ea-g"><span class="ea-l">Mês e Ano da Viatura *</span>' +
      '<div style="display:flex;gap:.5rem;flex-wrap:wrap">' +
      '<select name="properties[Mês da Viatura]" required style="max-width:200px">' + opts + '</select>' +
      '<input type="text" name="properties[Ano da Viatura]" inputmode="numeric" pattern="(19|20)[0-9]{2}" maxlength="4" placeholder="Ano (ex.: 2004)" title="Ano com 4 dígitos" required style="max-width:160px">' +
      '</div><div class="ea-n">Conforme o Documento Único Automóvel.</div></div>'));
  }
  if (CLS.indexOf(handle) > -1) {
    add(el('<div class="ea-g"><span class="ea-l">Classe do Veículo *</span>' +
      '<input type="text" name="properties[Classe do Veículo]" maxlength="1" placeholder="Ex.: A" title="Classe do veículo (1 letra)" required style="max-width:120px"></div>'));
  }

  // não deixa adicionar ao carrinho / comprar sem os campos obrigatórios
  function firstInvalid() {
    var l = w.querySelectorAll('[required]');
    for (var i = 0; i < l.length; i++) { if (!l[i].disabled && !l[i].checkValidity()) return l[i]; }
    return null;
  }
  function guard(e) {
    var b = firstInvalid();
    if (b) { e.preventDefault(); e.stopImmediatePropagation(); b.reportValidity(); try { b.focus(); } catch (x) {} }
  }
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.contains && e.target.contains(w)) guard(e);
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[name="add"],button[type="submit"],.shopify-payment-button,shopify-accelerated-checkout') : null;
    if (!t) return;
    var f = t.form || t.closest('form');
    if (f && f.contains(w)) guard(e);
  }, true);

  // faixa amarela com ano/mês na pré-visualização das placas 1998-2020
  if (pv && /1998/.test(title)) {
    var ms = w.querySelector('select[name="properties[Mês da Viatura]"]');
    var an = w.querySelector('input[name="properties[Ano da Viatura]"]');
    var pl = pv.querySelector('.ea-pl');
    if (ms && an && pl) {
      var yb = document.createElement('span');
      yb.style.cssText = 'flex:0 0 10%;min-width:0;overflow:hidden;background:#f2c500;display:flex;flex-direction:column;align-items:center;justify-content:center;font-family:"Helvetica Neue",Arial,sans-serif;font-weight:700;line-height:1;border-left:1px solid rgba(0,0,0,.15)';
      var y1 = document.createElement('span'), hr = document.createElement('span'), m1 = document.createElement('span');
      hr.style.cssText = 'display:block;width:70%;height:1px;background:currentColor;margin:.12em 0';
      yb.appendChild(y1); yb.appendChild(hr); yb.appendChild(m1); pl.appendChild(yb);
      var upd = function () {
        var y = (an.value || '').replace(/\D/g, ''), mm = (ms.value || '').slice(0, 2);
        y1.textContent = y.length === 4 ? y.slice(2) : 'AA';
        m1.textContent = mm || 'MM';
        yb.style.color = (y.length === 4 && mm) ? '#111' : '#8a7400';
        var two = (pl.clientWidth || 1) / (pl.clientHeight || 1) < 2.6;
        yb.style.flex = two ? '0 0 14%' : '0 0 10%';
        yb.style.fontSize = ((pl.clientHeight || 40) * (two ? 0.16 : 0.3)).toFixed(1) + 'px';
      };
      ms.addEventListener('change', upd); an.addEventListener('input', upd); window.addEventListener('resize', upd);
      upd(); setTimeout(upd, 300);
      setTimeout(function () { inp.dispatchEvent(new Event('input')); }, 350);
    }
  }
})();
